import realpressAdvancedSearch from './mixins/advanced-search';
import realpressTomSelect from '../mixins/tom-select';
import realpressSearchWithMap from './search-with-map/search-with-map';
import realpressSWMLayout from './search-with-map/switch-layout';
import realpressHeaderMap from './header-map/header-map';
import realpressHeaderMapLayout from './header-map/switch-layout';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressAdvancedSearch();
	realpressTomSelect();
	realpressSearchWithMap();
	realpressSWMLayout();
	realpressHeaderMap();
	realpressHeaderMapLayout();
} );
